import { Card, CardActionArea } from '@mui/material';
import clsx from 'clsx';
import ImagePreview from 'components/ImagePreview';
import { DATE_FORMAT } from 'const';
import React from 'react';
import ImageCardContent from './ImageCardContent';
import useImageUploadStyles from './styles';
import { ImageCardViewProps } from './types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ImageCardView: React.FunctionComponent<ImageCardViewProps> = (props) => {
  const { file, setPreviewImage, onDelete } = props;
  const classes = useImageUploadStyles();

  const selectedImage = () => {
    setPreviewImage?.(file!);
  };

  const renderImageCardView = () => {
    return (
      <>
        <Card
          className={clsx(classes.nonWimImageDark, classes.imageCardView, {
            [classes.selectedImage]: !!file?.selected,
          })}
          sx={{
            height: 150,
            width: 175,
          }}
        >
          <CardActionArea onClick={selectedImage}>
            <ImagePreview fileContent={file} height={100} size='small' />
            <ImageCardContent file={file} dateFormat={DATE_FORMAT} onDelete={onDelete} />
            {file?.selected && (
              <CheckCircleIcon className={classes.selectedImageIcon} color='secondary' />
            )}
          </CardActionArea>
        </Card>
      </>
    );
  };
  return renderImageCardView();
};

export default ImageCardView;
